import React from 'react';
import { noop } from 'lodash';
import { StyleSheet, View } from 'react-native';
import Logo from 'design-system/Logo';
import Text from 'design-system/Text';
import { IconArrow, rem, Spacer } from 'design-system';
import TouchableBounceCard from 'utils/packages/TouchableBounceCard';
import { formatNumberOfShares } from '../utils';
import { usePosition, useStockMeta } from '../hooks';
import useAssetSwitchPicker from '../hooks/useAssetSwitchPicker';
const AssetSwitchAssetCard = ({ assetId, fromAssetId, onSelectToAssetId }) => {
    const { name, iconUrl } = useStockMeta(assetId) || {};
    const [position] = usePosition(assetId, true);
    const availableToSell = formatNumberOfShares(position?.availableToSell || 0, true);
    const { isPickerOpen, onPress } = useAssetSwitchPicker(fromAssetId, assetId, onSelectToAssetId || noop);
    return (<TouchableBounceCard onDark noMarginTop noMarginBottom onPress={onPress} style={styles.card} disabled={!onSelectToAssetId}>
      <Logo R44 uri={iconUrl}/>
      <Spacer w={16}/>
      <View style={styles.flex}>
        <Text Text-16>{name}</Text>
        {!onSelectToAssetId && (<Text TextThin-14 Secondary>
            {availableToSell} available
          </Text>)}
      </View>
      {!!onSelectToAssetId && (<>
          <Spacer w={16}/>
          <IconArrow direction={isPickerOpen ? 'up' : 'down'}/>
        </>)}
    </TouchableBounceCard>);
};
const styles = StyleSheet.create({
    card: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingVertical: rem(24),
        paddingHorizontal: rem(16),
    },
    flex: {
        flex: 1,
    },
});
export default AssetSwitchAssetCard;
